<canvas #canvasEl [class.hidden]="!enabled"></canvas>
@if (loading) {
<app-loading-indicator color="white" class="image-loading-indicator" size="small"> </app-loading-indicator>
}
